export default "__VITE_ASSET__D7i0S9R1__"